import React, { Component } from "react";
import { observer } from "mobx-react";
import { fn_ygy_store_entry, fn_bm_store_entry } from "function/FnBodySetting"

@observer
class DeliveryConnectConfirm extends Component {
  render() {
    const { rootStore } = this.props;
    const layerStore = rootStore.layerStore;
    const title = layerStore.title();

    return (
      <div
        className={
          "layer_comm layer_common_type alert" +
          (layerStore.getLayerConfirmView ? " layer_open" : "")
        }
      >
        <div className="bg"></div>
        <div className="layer_content">
          <div className="wrap">
            <div className="top">
              <p>{title} 연동</p>
              <div className="btn_close btn_close_comm">
                <button onClick={() => layerStore.setLayerConfirmView(false)}>
                  <span>닫기</span>
                </button>
              </div>
            </div>
            <div className="content_cofirm">
              <div>
                <div className="img"></div>
                <p>{title} 계약 & 입점 후에</p>
                <p>배달매니저와 연동해주세요</p>
              </div>
            </div>
            <div className="view_bottom">
              <div>
                <div className="divider"></div>
              </div>
              <div className="btn_complete">
                {
                  (layerStore.tp == "YGY") ?
                    <button className="etc" onClick={() => {fn_ygy_store_entry(rootStore)}}>요기요 입점하러 가기<span className="ico"></span></button>
                    :
                    (layerStore.tp == "BMN") ?
                      <button className="etc" onClick={() => {fn_bm_store_entry(rootStore)}}>배민 입점하러 가기<span className="ico"></span></button>
                    : 
                      <button onClick={() => {layerStore.setLayerConfirmView(false);}}>확인</button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default DeliveryConnectConfirm;
